import { jsx as m } from "react/jsx-runtime";
import o from "classnames";
import { f as i } from "../../styled-qu50FBLM.mjs";
import { Svg as f, Path as d } from "./Elements.js";
const z = ({
  className: a = "",
  viewBox: h = "0 0 66.9 41",
  $cssHelper: t = i,
  focusable: r
}) => /* @__PURE__ */ m(
  f,
  {
    className: o({ [a]: !!a }),
    viewBox: h,
    $cssHelper: t,
    focusable: !!r,
    "aria-hidden": !r,
    children: /* @__PURE__ */ m(
      d,
      {
        d: "M4 0h58.95a4 4 0 0 1 4 4v33a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm.95 37.81h57a2 2 0 0 0 2-2V20.23h-61v15.58a2 2 0 0 0 2 2zm-2-27.16h61V5.19a2 2 0 0 0-2-2h-57a2 2 0 0 0-2 2zm4 22.9v-3.2h6.1v3.2zm7.56 0v-3.2h8.06v3.2z",
        fill: "#6D7788"
      }
    )
  }
);
export {
  z as default
};
